import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("cl_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("cl_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const loginWithToken = (token, userData) => {
    localStorage.setItem("cl_token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("cl_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginWithToken, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export const dashboardPath = (role) =>
  ({ client: "/espace-client", intervenant: "/espace-intervenant", poseur: "/espace-poseur", admin: "/admin" }[role] || "/");
